import { render, staticRenderFns } from "./FspAcknowledgeFormView.vue?vue&type=template&id=2a8b6956&"
import script from "./FspAcknowledgeFormView.vue?vue&type=script&lang=js&"
export * from "./FspAcknowledgeFormView.vue?vue&type=script&lang=js&"
import style0 from "./FspAcknowledgeFormView.vue?vue&type=style&index=0&id=2a8b6956&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports